import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ChatHeader from './ChatWindow/ChatHeader';
import ChatConversation from './ChatWindow/ChatConversation';
import ChatMessage from './ChatWindow/ChatMessage';
import Api from '../../services/ApiService';
import Socket from '../../services/SocketService';

class ChatWindow extends PureComponent {
  constructor(props) {
    super(props);

    this.addToBuffer = this.addToBuffer.bind(this);
    this.handleHeaderClick = this.handleHeaderClick.bind(this);
    this.minimize = this.minimize.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.syncBuffer = this.syncBuffer.bind(this);

    // Create predictable conversation id 1.1 1.2 <userid>.<userid>
    this.conversationId = [props.me, props.room].sort().join('.');

    this.state = {
      conversation: [],
      minimized: false,
    };
  }

  componentDidMount() {
    this.syncBuffer();

    Socket.chat
      .on('connect', this.syncBuffer)
      .on(`@${this.conversationId}.message`, this.addToBuffer);
  }

  componentWillUnmount() {
    Socket.chat
      .off('connect')
      .off(`@${this.conversationId}.message`);
  }

  /**
   * Minimize button handler
   * @param {Object} event
   * @return
   */
  minimize(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ minimized: true });
  }

  /**
   * Fetch and store conversation to state
   * @return
   */
  syncBuffer() {
    const { room } = this.props;

    Api.get(`chat/user/${room}`).then((response) => {
      const { buffer = [] } = response.data;

      const conversation = [];
      // quickly reverse order
      for (let i = buffer.length - 1; i >= 0; i -= 1) {
        try {
          conversation.push(JSON.parse(buffer[i]));
        } catch (e) {
          // filter out malformed junk
          console.log(e.message);
        }
      }

      this.setState({ conversation }, () => { this.chatConversation.scrollToBottom(false); });
    });
  }

  /**
   * Add a new message at the end of the conversation
   * @param {Object} message
   * @return
   */
  addToBuffer(message) {
    const { conversation } = this.state;

    this.setState(
      { conversation: [...conversation, message] },
      this.chatConversation.scrollToBottom,
    );
  }

  /**
   * Header click handler.  Restores window of minimized. Also focuses
   * ChatWindowMessage.
   * @return
   */
  handleHeaderClick() {
    if (this.state.minimized) {
      this.setState({ minimized: false }, () => { this.chatMessage.setFocus(); });
    } else {
      this.chatMessage.setFocus();
    }
  }

  /**
   * Sends new message to the conversation
   * @param {String} message
   * @return
   */
  sendMessage(message = '') {
    const { room } = this.props;
    this.props.send(room, message);
  }

  render() {
    const { me, title, room, status, style, active, avatar } = this.props;

    const className = classNames({
      'chat-window': true,
      minimized: this.state.minimized,
      active,
    });

    return (
      <div className={className} style={style} onClick={() => { this.props.setActive(room); }}>
        <ChatHeader
          onClick={this.handleHeaderClick}
          minimize={this.minimize}
          status={status}
          close={this.props.close}
        >
          {title}
        </ChatHeader>
        <ChatConversation
          conversation={this.state.conversation}
          me={me}
          ref={(c) => { this.chatConversation = c; }}
          status={status}
          avatar={avatar}
        />
        <ChatMessage
          sendMessage={this.sendMessage}
          ref={(c) => { this.chatMessage = c; }}
          close={this.props.close}
        />
      </div>
    );
  }
}

ChatWindow.propTypes = {
  active: PropTypes.bool,
  avatar: PropTypes.string,
  close: PropTypes.func,
  me: PropTypes.number,
  room: PropTypes.number,
  send: PropTypes.func,
  setActive: PropTypes.func,
  status: PropTypes.oneOf(['Available', 'Offline', 'Busy', 'Away']),
  style: PropTypes.object,
  title: PropTypes.string,
};

ChatWindow.defaultProps = {
  room: 'Ghost',
  style: {},
};

export default ChatWindow;
